export default "__VITE_ASSET__x2be2dpE__"